var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-layout',{attrs:{"row":""}},[_c('v-flex',{staticClass:"pa-0",attrs:{"md2":""}},[_c('sub-side-bar',{attrs:{"items":_vm.settingsMenu}})],1),_c('v-flex',{attrs:{"md10":""}},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }